import { cn } from "@penmate/react-shared/lib/utils";

export const OPTION_CARD_BASE =
  "rounded-xl border px-3 py-3 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4b46a4a3]/25 focus-visible:ring-offset-2 focus-visible:ring-offset-background";

export const OPTION_CARD_UNSELECTED =
  "border-input bg-white/70 hover:bg-white active:bg-white";

export const OPTION_CARD_SELECTED =
  "border-[#4b46a4a3] bg-white shadow-sm ring-2 ring-[#4b46a4a3]/25";

export const OPTION_CARD_DISABLED = "opacity-60 cursor-not-allowed";

export function optionCardClass(args: {
  selected: boolean;
  disabled?: boolean;
  className?: string;
}): string {
  return cn(
    OPTION_CARD_BASE,
    args.selected ? OPTION_CARD_SELECTED : OPTION_CARD_UNSELECTED,
    args.disabled ? OPTION_CARD_DISABLED : null,
    args.className,
  );
}

